module.exports = __webpack_public_path__ + "img/banner-principal.5ac39360.svg";